/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import EventEmitter from 'eventemitter3';
import isNil from 'lodash/isNil';

/**
 * Naslouchač událostem v ovládání pro standardní webové technologie.
 * Je navázaný na standardní DOM rozhraní pro stisky kláves.
 * Filtruje události a převádí je do {@link EventBus} rozhraní pro události.
 * @implements {ControlListener}
 */
class WebControlListener {
  /**
   * Vytvoří instanci.
   * @param {ControlParser} parser Převaděč kódů tlačítek na číselník.
   */
  constructor(parser) {
    this.emitter = new EventEmitter();
    this.parser = parser;
    // Navázání naslouchání na instanci.
    this.onKeydown = this.onKeydown.bind(this);
    // Naslouchání událostem.
    document.addEventListener('keydown', this.onKeydown);
  }

  /** @inheritdoc */
  destroy() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  /** @inheritdoc */
  off(type, callback) {
    this.emitter.off(type, callback);
  }

  /** @inheritdoc */
  on(type, callback) {
    this.emitter.on(type, callback);
  }

  /**
   * Reakce na stisk tlačítka.
   * @param {KeyboardEvent} event Vyvolaná událost.
   * @private
   * @returns {undefined} Nic.
   */
  onKeydown(event) {
    const controlButton = this.parser.parseKeyCode(event.keyCode);
    if (!isNil(controlButton)) {
      this.emitter.emit('buttonDown', controlButton);
    }
  }
}

export default WebControlListener;
